import clock from './clock';
import column from './column';
import guide from './guide';
import popular from './popular';
import ring from './ring';
import todo from './todo';

export default{ clock,guide,popular,todo,column,ring };
